module.exports = __webpack_public_path__ + "static/media/A R I Z O N A - Nostalgic [Official Music Video].3eba49ac.mp3";